import React, { useMemo } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { useCopilotDomainDataRepository } from './repository/copilotDomainDataRepository';

export const withCopilotDomainDataService = (WrappedComponent) => {
  const Wrapper = (props) => {
    const dataService = useCopilotDomainDataRepository();
    const {
      getAudioList,
      getVideoTemplates,
    } = dataService;
    const copilotDomainDataService = useMemo(() => ({
      getAudioList,
      getVideoTemplates,
    }), [getAudioList, getVideoTemplates]);

    return (
      <WrappedComponent
        {...props}
        copilotDomainDataService={copilotDomainDataService}
      />
    );
  };

  Wrapper.displayName = `withCopilotDomainDataService(${getDisplayName(WrappedComponent)})`;

  hoistNonReactStatics(Wrapper, WrappedComponent);

  return Wrapper;
};
